export const SITE_URL = "https://yegnataxi.com";

export const ORGANIZATION = {
  tradeName: "YegnaTaxi",
  provider: "AD Technologies and Trading",
  address: "Addis Ababa, Kirkos Sub-City, Woreda 08, House No. 3-310, Ethiopia",
} as const;

export type Locale = "en" | "am";
export type AppKind = "rider" | "driver";
export type LegalKind = "privacy" | "terms";

// Replace each TODO with the final store listing before launch. The UI presents these
// as "coming soon" until a real HTTPS destination is configured.
export const STORE_URLS = {
  rider: {
    googlePlay: "TODO",
    appStore: "TODO",
  },
  driver: {
    googlePlay: "TODO",
    appStore: "TODO",
  },
} as const;

export type Route =
  | { locale: Locale; page: "home" }
  | { locale: Locale; page: "legal"; app: AppKind; legal: LegalKind }
  | { locale: Locale; page: "not-found" };

const LOCALES: readonly Locale[] = ["en", "am"];
const APPS: readonly AppKind[] = ["rider", "driver"];
const LEGAL_KINDS: readonly LegalKind[] = ["privacy", "terms"];

export function parseRoute(pathname: string): Route {
  const segments = pathname.split("/").filter(Boolean);

  if (segments.length === 0) return { locale: "en", page: "home" };

  const locale = LOCALES.includes(segments[0] as Locale)
    ? (segments[0] as Locale)
    : "en";

  if (segments.length === 1 && LOCALES.includes(segments[0] as Locale)) {
    return { locale, page: "home" };
  }

  if (
    segments.length === 3 &&
    LOCALES.includes(segments[0] as Locale) &&
    APPS.includes(segments[1] as AppKind) &&
    LEGAL_KINDS.includes(segments[2] as LegalKind)
  ) {
    return {
      locale,
      page: "legal",
      app: segments[1] as AppKind,
      legal: segments[2] as LegalKind,
    };
  }

  return { locale, page: "not-found" };
}

export function pathFor(locale: Locale, app?: AppKind, legal?: LegalKind): string {
  if (app && legal) return `/${locale}/${app}/${legal}`;
  return locale === "en" ? "/" : "/am";
}

export function alternateLocale(locale: Locale): Locale {
  return locale === "en" ? "am" : "en";
}
